export default __webpack_public_path__ + "static/media/capriciossa.fe1a1423.png";